const AWAITING_MOBLY = { type: 'awaiting_mobly', name: 'Em andamento' }
const AWAITING_CUSTOMER = { type: 'awaiting_customer', name: 'Aguardando seu preenchimento' }
const DONE = { type: 'done', name: 'Atendimento finalizado' }
const CANCELED = { type: 'canceled', name: 'Atendimento cancelado' }
const POSSIBLE_TICKET_STATUS_TYPES = [AWAITING_MOBLY, AWAITING_CUSTOMER, DONE, CANCELED]

export {
  AWAITING_MOBLY,
  AWAITING_CUSTOMER,
  DONE,
  CANCELED,
  POSSIBLE_TICKET_STATUS_TYPES
}
